import { getMedPayPolicyLimitsLabel, getMedPayPolicyStatusLabel, getMedPayPolicyStatusLabelMP } from "../../../../../lib/labels";
import { isStateOfPip } from "../../../../../lib/script";
import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import SimpleBoxDisplay from "../../../../common/SimpleBoxDisplay";
import CaseSummaryBox from "../CaseSummaryBox";

export default function MedPaySummary({primaryMpPipUm, classes, activeCase}) {
    return <CaseSummaryBox title={'Med pay'} tabNumber={2} type={'mp_pip_um'}>
        {primaryMpPipUm && <>
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Name'} value={primaryMpPipUm.insurance_carrier.name}/>
            </div>
            {isStateOfPip(primaryMpPipUm?.insurance_state) && <div className={classes.row}>
                {primaryMpPipUm.has_pip == 1 ? <CheckboxCell checked={true} label={'PIP'} isDisabled={true} direction={'reverse'}/> 
                    : 
                    ''}
                {primaryMpPipUm.has_pip == 0 ? <CheckboxCell checked={true} label={'No PIP'} isDisabled={true} direction={'reverse'} trueFlagDanger={true}/>
                    : 
                    ''
                }
                <SimpleBoxDisplay label={'PIP Limit'} value={getMedPayPolicyLimitsLabel(primaryMpPipUm.pip_policy_limit)}/>
                <SimpleBoxDisplay label={'PIP Status'} value={getMedPayPolicyStatusLabel(primaryMpPipUm.pip_status)}/>
                {(primaryMpPipUm.pip_exausted == 1 || primaryMpPipUm.pip_exausted == true) ? <CheckboxCell label={'Exhausted'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'danger'}/> : '' }
            </div>}
            <div className={classes.row}>
                {primaryMpPipUm.has_mp == 1 ? <CheckboxCell checked={true} label={'MP'} isDisabled={true} direction={'reverse'}/> 
                : 
                ''}
                {primaryMpPipUm.has_mp == 0 ? <CheckboxCell checked={true} label={'No MP'} isDisabled={true} direction={'reverse'} trueFlagDanger={true}/>
                : 
                ''
                }
                <SimpleBoxDisplay label={'MP Limit'} value={getMedPayPolicyLimitsLabel(primaryMpPipUm.mp_policy_limit)}/>
                <SimpleBoxDisplay label={'MP Status'} value={getMedPayPolicyStatusLabelMP(primaryMpPipUm.mp_status)}/>
                {(primaryMpPipUm.mp_exausted == 1 || primaryMpPipUm.mp_exausted == true) ? <CheckboxCell label={'Exhausted'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'danger'}/> : '' }
            </div>               

            <div className={classes.row}>
                {primaryMpPipUm.vehicle_make && <SimpleBoxDisplay label={'Vehicle Make'} value={primaryMpPipUm.vehicle_make}/>}
                {primaryMpPipUm.vehicle_model && <SimpleBoxDisplay label={'Vehicle Model'} value={primaryMpPipUm.vehicle_model}/>}
                {primaryMpPipUm.vehicle_year && <SimpleBoxDisplay label={'Vehicle Year'} value={primaryMpPipUm.vehicle_year}/>}
            </div>
            {primaryMpPipUm.vehicle_damage && <div className={classes.row}>
                <SimpleBoxDisplay label={'Vehicle Damage'} value={primaryMpPipUm.vehicle_damage}/>
            </div>}
        </>}
        {!primaryMpPipUm && <>No primary MedPay selected!</>}
    </CaseSummaryBox>
}